import axiosInstance from "../Shared/Utils/axiosInstance";
export const sendOtpFromServer = async (contact) => {
  return await axiosInstance.post(`/api/forgotPassword`, {
    mobilenumber: contact,
  });
};

export const resendOtpFromServer = async (reqBody) => {
  return await axiosInstance.post(`/api/resendOtp`, reqBody);
};

export const verifyOtpFromServer = async (newUser, otp, password, contact) => {
  return await axiosInstance.post(`/api/resetPassword`, {
    mobilenumber: contact,
    otp: otp,
    newpassword: password,
  });
};

export const verifyOtpForNewUserFromServer = async (contact, otp) => {
  return await axiosInstance.post(`/api/verifyOTP`, {
    mobilenumber: contact,
    otp: otp,
  });
};
